import React from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { WagmiProvider } from 'wagmi'
import { Provider } from 'react-redux'
import { Store } from '@reduxjs/toolkit'
import { ToastsProvider } from 'contexts/ToastsContext'
import { ConnectPanelProvider } from 'contexts/ConnectPanel'
import { RefreshContextProvider } from 'contexts/RefreshContext'
import { ThemeContextProvider } from './ThemeContext'
import { wagmiConfig, wagmiQueryClient } from 'lib/wagmiConfig'
import { ModalProvider, NavbarProvider } from '@mprolab/uikit'

interface IProviders {
  children: React.ReactNode
  store: Store
}

const Providers: React.FC<IProviders> = ({ children, store }) => {
  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={wagmiQueryClient}>
        <ToastsProvider>
          <Provider store={store}>
            <ConnectPanelProvider>
              <ThemeContextProvider>
                <ModalProvider>
                  <RefreshContextProvider>
                    <NavbarProvider>{children}</NavbarProvider>
                  </RefreshContextProvider>
                </ModalProvider>
              </ThemeContextProvider>
            </ConnectPanelProvider>
          </Provider>
        </ToastsProvider>
      </QueryClientProvider>
    </WagmiProvider>
  )
}

export default Providers
